export default __webpack_public_path__ + "static/e-commerce-7651f8ff3a7712c0f4bb6f54a83b5cd1.png";